import * as React from "react";

function SvgExclamationCircle(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="1em" height="1em" {...props}><path d="M44.4 22.8h11.4l-2.2 37.5h-7l-2.2-37.5zM55 68.2v9.4h-9.7v-9.4H55z" /><path d="M50 100.2c-27.6 0-50-22.4-50-50S22.4.2 50 .2s50 22.4 50 50c0 27.5-22.4 50-50 50zm0-96c-25.4 0-46 20.6-46 46s20.6 46 46 46 46-20.6 46-46-20.6-46-46-46z" /></svg>;
}

export default SvgExclamationCircle;